import { createContext, useContext } from 'react'

/**
 * Whether `appDocs` on screen came from the network on this page load, not only from the
 * IndexedDB-persisted cache. AuthorizeUser renders the app as soon as a cached copy exists, so
 * until the `cache-and-network` request returns, the options and rates in use can be days old.
 * The stale-settings notice (#25436) waits for this, or that old copy would raise a false notice.
 */
export const AppDocsFreshContext = createContext(false)

export function useAppDocsFresh(): boolean {
  return useContext(AppDocsFreshContext)
}
